/* eslint-disable no-underscore-dangle */
import Form from './form';
import OfferPAP from './offerPAP';
import SiteLicense from './siteLicense';

class Offer {
  constructor(data, url) {
    this.id = data.id;
    this.url = url;
    this.name = data.on;
    this.oi = data.oi;
    this.type = data.t;
    this.closeable = data.cl;
    this.hasCustomCSS = data.tc != null;
    this.hasCheckout = data.hch;
    this.customCSSLink = data.tc;
    this.isLandingOffer = false;
    this.template = {
      offerTemplateCardType: this.type,
      isClosable: this.closeable,
      hasCustomCSS: this.hasCustomCSS,
      customCSSLink: this.customCSSLink,
      elementId: 'offercard',
      hasCustomHeader: !!data.th,
      hasCustomFooter: !!data.tf,
      customHeader: data.th,
      customFooter: data.tf,
    };
    this.templateCard = data.c.s;

    this.templateCardItems = data.ci.map((x) => x.s);
    this.paps = data.pap ? data.pap.map((p) => new OfferPAP(p)) : [];
    // this.paps = []
    this.licenses = data.l ? data.l.map((x) => new SiteLicense(x)) : [];
    // this.licenses = []
    this.forms = data.f ? data.f.map((x) => new Form(x)) : [];
    // this.forms = []
  }

  getTemplateCard() {
    try {
      const templCard = JSON.parse(this.templateCard);
      // templCard._buttonRedirectUrlToggle = true;
      // templCard._buttonRedirectUrl = 'http://localhost:8082/landing.html'
      if (this.checkIfPageIsLanding()) {
        templCard._buttonRedirectUrlToggle = false;
      }
      return templCard;
    } catch (e) {
      return {};
    }
  }

  getIsLandingOffer() {
    try {
      if (this.checkIfPageIsLanding()) {
        this.isLandingOffer = true;
      }
      // console.log('ISLANDINGOFFER ', this.isLandingOffer);
      return this.isLandingOffer;
    } catch (e) {
      return false;
    }
  }

  checkIfPageIsLanding() {
    try {
      const templCard = JSON.parse(this.templateCard);

      return templCard._buttonRedirectUrlToggle && this.url.includes(templCard._buttonRedirectUrl);
    } catch (e) {
      return false;
    }
  }

  getTemplateCardItems() {
    try {
      const cardItems = this.templateCardItems.map((x) => JSON.parse(x));
      cardItems.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item._offerTemplateCardItemIsLoading = false;
      });
      return cardItems;
    } catch (e) {
      return [];
    }
  }
}

export default Offer;
